var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-view'),_c('AppDialog',{attrs:{"componentList":_vm.dialogList}}),_c('Snackbar'),_c('ConfirmDialog',{attrs:{"confirmDialogList":_vm.confirmDialogList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }